import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const TagContainer = styled('div')`
  color: var(--white);
  height: fit-content;
  max-width: 15em;
  padding: 0.25em;
  border-radius: var(--ph-border-radius-sm);
  border: 0;
  background-color: var(--ph-light-blue-400);
  justify-content: center;
  align-items: center;
  margin: 0.1em 0.2em;
`;

const TagContainerInner= styled('div')`
  display: flex;
  justify-content: center;
`;

const TagText = styled('span')`
  border-radius: var(--ph-border-radius-sm);
  font-size: small;
  margin-right: 2px;
  line-height: 1.5em;
`;

const CloseIcon = styled(Svg)`
  cursor: pointer;
  height: 10px !important;
  width: 10px !important;
  max-height: 10px;
  max-width: 10px;
  position: relative;
  line-height: 1em;
  top: 2px;
  margin-left: 1em;

  path {
    fill: var(--white);
  }

`;

export default {
  CloseIcon,
  TagContainer,
  TagContainerInner,
  TagText
};
